import React, { memo, useCallback, useState } from "react";
import DashboardHeader from "../../../components/common/DashboardHeader";
import TaskSummaryCards from "../../../components/common/TaskSummaryCards";
import DashboardAttentionAlerts from "../../../components/common/DashboardAttentionAlerts";
import DashboardTrendCharts from "../../../components/common/DashboardTrendCharts";
import TaskSummaryTable from "../../../components/common/TaskSummaryTable";
import TatOverduePanel from "../../../components/common/TatOverduePanel";
import taskSummaryData from "../../../data/dashboard/taskSummary.json";
import attentionAlertsData from "../../../data/dashboard/attentionAlerts.json";
import summaryMetricsData from "../../../data/dashboard/summaryMetrics.json";
import dashboardHeaderData from "../../../data/dashboard/dashboardHeader.json";
import completionTrendData from "../../../data/dashboard/completionTrend.json";
import overdueTrendData from "../../../data/dashboard/overdueTrend.json";
import tatByPersonData from "../../../data/dashboard/tatByPerson.json";
import overdueTasksData from "../../../data/dashboard/overdueTasks.json";
import "./Dashboard.css";

const DASHBOARD_TABS = [
  { id: "task-summary", label: "Task Summary" },
  { id: "tat-overdue", label: "TAT & Overdue" },
];

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("task-summary");
  const [selectedDepartmentId, setSelectedDepartmentId] = useState("all");

  const handlePersonClick = useCallback(() => {}, []);
  const handleAlertAction = useCallback(() => {}, []);
  const handleHeaderAction = useCallback(() => {}, []);

  return (
    <div className="dashboard-page">
      <DashboardHeader
        title={dashboardHeaderData.title}
        subtitle={dashboardHeaderData.subtitle}
        departments={dashboardHeaderData.departments}
        selectedDepartmentId={selectedDepartmentId}
        onDepartmentSelect={setSelectedDepartmentId}
        onTimePeriodClick={handleHeaderAction}
        onTeamsClick={handleHeaderAction}
        onExportClick={handleHeaderAction}
      />

      <div className="dashboard-summary-cards">
        <TaskSummaryCards cards={summaryMetricsData.cards} />
      </div>

      <DashboardAttentionAlerts
        items={attentionAlertsData.items}
        totalCount={attentionAlertsData.totalCount}
        onFollowUp={handleAlertAction}
        onReassign={handleAlertAction}
        onPersonClick={handlePersonClick}
        onShowMore={handleAlertAction}
      />

      <div className="dashboard-charts-section">
        <DashboardTrendCharts
          completionPoints={completionTrendData.points}
          overdueRows={overdueTrendData.rows}
        />
      </div>

      <div className="dashboard-panel">
        <div className="dashboard-tabs" role="tablist" aria-label="Dashboard views">
          {DASHBOARD_TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={`dashboard-tab${activeTab === tab.id ? " dashboard-tab--active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="dashboard-panel-content">
          {activeTab === "task-summary" ? (
            <TaskSummaryTable
              rows={taskSummaryData.rows}
              onPersonClick={handlePersonClick}
            />
          ) : (
            <TatOverduePanel
              tatByPersonRows={tatByPersonData.rows}
              overdueTaskRows={overdueTasksData.rows}
              onPersonClick={handlePersonClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(Dashboard);
